angular.module('leanlaw').directive('llServiceSetup', ['$timeout', function ($timeout) {
  return {
    restrict: "EA",
    require: "ngModel",
    replace: true,
    template: require("./views/serviceSetup.html"),
    scope: {
      ngModel: "=",
      filteredServices: "=",
      services: "="
    },
    link: function ($scope, element, attrs) {
      console.log($scope.ngModel, $scope.data);
      $scope.exists = function () {
        return $scope.services && $scope.services.find(s => s.name == $scope.ngModel.name);
      };
    }
  };
}]);